import React, { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import Dropdown from 'meinian-package/src/baseComponent/dropdown'
import Icon from 'meinian-package/src/component/icon'
import styles from './index.module.less'

const _fromData = (values) => {
  return values.map(item => {
    if (typeof item === 'string') {
      return { value: item }
    }
    return { ...item, value: item.value }
  })
}

export default ({ label, values, fromData = _fromData, onClickTag = null, mb12 = true, style = null }) => {
  const scrollWrapRef = useRef(null)
  const _values = fromData(values)
  const [hasMore, setHasMore] = useState(false)
  const [open, setOpen] = useState(false)
  useEffect(() => {
    if (scrollWrapRef.current.scrollHeight > 40) {
      setHasMore(true)
    }
  }, [scrollWrapRef.current?.scrollHeight])

  return <div className={classNames(styles['mn-multi-item-wrap'], { mb12 })} style={style}>
    <div className="label">{label}</div>
    <div className="item-name-wrap">
      <div ref={scrollWrapRef} className={classNames('item-wrap', { empty: !_values?.length })}>{_values?.length > 0 ? _values?.map(value => <a
        className="item"
        onClick={() => {
          onClickTag?.(value.value, value)
        }}
      >{value.value}</a>) : '未填写'}
      </div>
      {
        hasMore && <Dropdown
          open={open}
          onOpenChange={vis => setOpen(vis)}
          trigger="click"
          overlay={<div className="item-more-wrap">{
            _values?.map(value => <a
              className="item"
              style={{ marginBottom: '8px' }}
              onClick={() => {
                onClickTag?.(value.value, value)
              }}
            >{value.value}</a>)
          }</div>}
          getPopupContainer={triggerNode => triggerNode.parentElement}
        >
          <div className={classNames('item', 'fill-white-bg', { more: true, active: open })}><Icon type="m-gengduo" /></div>
        </Dropdown>
      }
    </div>
  </div>
}
